<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(tab, index) in tabs" :label="tab.desc" :key="index">
            </el-tab-pane>
        </el-tabs>
        <el-form ref="searchForm" :model="searchData" inline>
            <el-form-item label="产品类型">
                <el-select v-model="searchData.type" size="mini" placeholder="请选择" class="policy-box-input">
                    <el-option
                        v-for="(opt, key, index) in productTypeList"
                        :key="index"
                        :label="opt.desc"
                        :value="opt.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应链">
                <el-select v-model="searchData.supply_chain_id" size="mini" placeholder="请选择" class="policy-box-input">
                    <el-option
                        v-for="(opt, key, index) in supplyChainList"
                        :key="index"
                        :label="opt.name"
                        :value="opt.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="产品是否未绑定">
                <el-select v-model="searchData.unbind" size="mini" placeholder="请选择" class="policy-box-input">
                    <el-option
                        v-for="(opt, key, index) in unbindOptions"
                        :key="index"
                        :label="opt.label"
                        :value="opt.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="mini" @click="handlerSearch">
                    查找
                </el-button>
            </el-form-item>
        </el-form>

        <el-table
            :data="data"
            @sort-change="handlerSort"
            :default-sort = "{prop: 'weight', order: 'descending'}"
        >
            <el-table-column
                prop="id"
                label="供应链产品ID"
            />
            <el-table-column
                label="供应链"
            >
                <template slot-scope="scope">
                    {{ getSupplyChain(scope.row.supply_chain_id) }}
                </template>
            </el-table-column>
            <el-table-column 
                label="产品名称"
            >
                <template slot-scope="scope">
                    <span @click="handleToPage(scope.row.link_url)" v-if="scope.row.link_url" style="color: #409EFF;">{{scope.row.name}}</span>
                    <span v-else>{{scope.row.name}}</span>
                </template>
            </el-table-column>
            <el-table-column label="产品类型">
                <template slot-scope="scope">
                    {{ getProductType(scope.row.type) }}
                </template>
            </el-table-column>
<!--            <el-table-column
                label="产品状态">
                <template slot-scope="scope">
                    {{ getProductStatus(scope.row.status) }}
                </template>
            </el-table-column>-->
            <el-table-column
                prop="user_id"
                label="关联产品"
            >
                <template slot-scope="scope">
                    <div class="edit-btn-box">
                        <el-button size="mini" @click="handleBindProductDialog(scope.row)" type="primary">编辑</el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="user_id"
                label="操作"
            >
                <template slot-scope="scope">
                    <div class="edit-btn-box">
                        <el-button size="mini" @click="handleEdit(scope.row)" type="primary">查看</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page-bar
            :pageSize="50"
            :currentPageCount="data.length"
            @page-changed="loadData"
            :pageSizes="pageSizes"
        ></page-bar>
        <el-dialog :visible.sync="showViewDetail">
            <el-form label-position="right">
                <el-form-item label="产品id：" label-width="150px">
                    <el-input v-model="detailData.id" disabled></el-input>
                </el-form-item>
                <el-form-item label="供应链：" label-width="150px">
                    <el-input :value="getSupplyChain(detailData.supply_chain_id)" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="产品名称：" label-width="150px">
                    <el-input v-model="detailData.name" disabled="disabled"></el-input>
                </el-form-item> 
                <el-form-item label="产品类型：" label-width="150px">
                    <el-input :value="getProductType(detailData.type)" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="产品状态：" label-width="150px">
                    <el-input :value="getProductStatus(detailData.status)" disabled></el-input>
                </el-form-item>
                <el-form-item label="投保链接：" label-width="150px">
                    <el-input v-model="detailData.link_url" type="textarea" disabled></el-input>
                </el-form-item>
                <el-form-item label="最低推广费率：" label-width="150px">
                    <el-input v-model="detailData.min_fee" type="textarea" disabled></el-input>
                </el-form-item>
                <el-form-item label="最高推广费率：" label-width="150px">
                    <el-input v-model="detailData.max_fee" type="textarea" disabled></el-input>
                </el-form-item>
                <el-form-item label="推广费详情表：" label-width="150px">
                    <el-button type="info" size="mini" @click="checkRate">查看</el-button>
                </el-form-item>
                <el-form-item label="绑定的主产品id：" label-width="150px">
                    <el-input v-model="detailData.product_main_id" type="textarea" disabled v-if="detailData.product_main_id !== 0"></el-input>
                </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showViewDetail = false">取 消</el-button>
                <el-button type="primary" @click="currentDataModify">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="showRateViewDetail">
            <el-table
                :data="fee_table"
            >
                <el-table-column
                    prop="payDesc"
                    label="缴费年限"
                />
                <el-table-column
                    prop="firstRate"
                    label="首年费率(%)"
                />
                <el-table-column
                    prop="insureDesc"
                    label="保障期限"
                />
                <el-table-column
                    prop="secondRate"
                    label="次年费率(%)"
                />
            </el-table>
        </el-dialog>
        <el-dialog :visible.sync="showBindProduct">
            <el-form inline>
                <el-form-item label="图羚产品库ID"> 
                    <el-input v-model.number="productId" size="small"  />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="findProduct(productId)">查找</el-button>
                </el-form-item>
            </el-form>
            <div>
                {{ `${supplyChain}      ${productName}` }}
<!--                <el-button size="mini" type="info" @click="handleBindBtnClick('unbind')" v-if="unbindtype">解除绑定</el-button>-->
            </div><br />
            
            <el-button size="small" type="primary" @click="handleBindBtnClick('bind')">绑定产品</el-button>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <span v-if="bindBtnType ==='unbind'">确定要解除此产品吗？</span>
            <span v-else>确定要绑定此产品吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible  = false">取 消</el-button>
                <el-button type="primary" @click="bindProduct">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import PageBar from "@/modules/ui/PageBar"
import request from "@/api/request";

const suitOptions =  {
    all: '全部',
    health: '医疗',
    accident: '意外',
    life: '人寿',
    illness: '重疾',
    travel: '航旅',
    physical: '体检',
    property: '财产',
    gene: '基因',
    annuity: '年金',
    unknown: '其他'
}
const providerOptions = {
    all: '全部',
    iyb: 'I云保'
}

const unbindOptions = [{label: '待分配', value: 1},{label: '所有', value: 2}]

export default {
    components: {
        PageBar
    },
    data(){
        return {
            pageSizes: [10, 20, 50],
            currentRange: [0, 50],
            filter: {
                status: [1],
                unbind: true
            },
            defaultPageIndex: 1,
            activeName: '',
            data: [],
            searchData: {
                supply_chain_id: '',
                unbind: 1,
                type: ''
            },
            sort: [
                {
                    field: 'weight',
                    reverse: true
                }
            ],
            suitOptions,
            providerOptions,
            unbindOptions,
            tabs: [],
            tabIndex: 0,
            status: 1,
            showViewDetail: false,
            showRateViewDetail: false,
            showBindProduct: false,
            dialogVisible: false,
            detailData: {
                commission_data: {
                    rate_list: []
                }
            },
            currentId: null,
            fee_table: [],
            supplyChainList: [],
            productTypeList: [],//产品类型信息
            productId: '',
            productName: '',
            supplyChain: '',
            unbindtype: false,
            bindBtnType: '',
            bindData: {}, //关联或解绑数据
            bindProductList: {}
        }
    },
    mounted() {
        this.getInit()
    },
    created() {
        this.loadData([0, 50]);
    },
    methods: {
        loadData(range){
            this.data = [];
            this.currentRange = range;
            request.saas
                .post("product/get_supply_chain_product_list", {
                    range: range,
                    filter: this.filter
                })
            .then(res => {
                this.data = res.data.list
            })
        },
        getInit(){
            //获取供应链产品状态信息.在售/停售
            request.saas
                .post("product/supply_chain_product_status_list", {})
                .then(resp => {
                    this.tabs = resp.data.list
                })  
            //获取供应链信息
            request.saas
                .post("product/supply_chain_list", {})
                .then(resp => {
                    this.supplyChainList = resp.data.list
                })
            //获取产品类型信息
            request.saas
                .post("product/product_type_list", {})
                .then(resp => {
                    this.productTypeList = resp.data.list
                })
        },
        async handleBindProductDialog(item) {
            this.productName = ''
            this.productId = ''
            this.supplyChain = ''
            this.unbindtype = false
            if(item.product_main_id) {
                //已绑定产品
                this.unbindtype = true
                let result = await this.getProductInfo(item.product_main_id)
                this.productName = result.name
                this.supplyChain = this.getSupplyChain(item.supply_chain_id)
                this.bindData = {
                    product_id: item.id, //供应链产品id
                    supply_chain_id: item.supply_chain_id, //供应链id	
                    product_main_id: 0 // 0表示解绑
                }
            } else {
                this.bindData = {
                    product_id: item.id, //供应链产品id
                    supply_chain_id: item.supply_chain_id, //供应链id	
                    product_main_id: 0 // 0表示解绑
                }
            }
            
            this.showBindProduct = !this.showBindProduct
        },
        async findProduct(id) {
            //查找产品product/getProductInfo  
            if (!id) return
            this.getProductInfo(id)
        },
        getProductInfo(id){
            return new Promise(resolve=>{
                request.saas
                    .post("product/get_product_info", {
                        id: id,
                        need_supply_chain: false
                    })
                    .then(resp => {
                        this.productName = resp.data.name
                        resolve(resp.data)
                    })
                    .catch(() => {
                        resolve({})
                    })
            })
        },
        handleBindBtnClick(n) {
            this.dialogVisible = true
            this.bindBtnType = n
        },
        handleToPage(url){
            window.open(url,"_blank");
        },
        bindProduct(){
            //解绑、绑定产品
            if(this.bindBtnType === 'bind') {
                if(!this.productId) {
                    this.$message.info('请确定要绑定的产品')
                    return
                }
                this.bindData.product_main_id = parseInt(this.productId) //重新赋值为绑定新产品，否则为解绑值为0
            }
            
            request.saas
                .post("product/bind_supply_chain_product", this.bindData)
                .then(() => {
                    this.loadData(this.currentRange);
                    this.dialogVisible = false
                    this.showBindProduct = !this.showBindProduct
                    this.productId = ''
                    this.productName = ''
                    
                })
        },
        handleClick(tab){
            //tab切换
            this.tabIndex = tab.index
            this.status = this.tabs[tab.index].value
            this.filter ={
                status: [this.status]
            }
            this.data = []
            this.searchData = {
                supply_chain_id: '',
                unbind: 1,
                type: ''
            }
            this.loadData(this.currentRange)
        },
        onDataChanged: function (data) {
            this.data = data
        },
        handleEdit(item){
            this.detailData = item
            this.fee_table = JSON.parse(item.fee_table)
            this.showViewDetail = !this.showViewDetail
        },
        updateWeight(item){
            request.product
                .post("manage_weight_update", {
                    id: item.id,
                    weight: item.weight
                })
                .then(() => {
                    this.$message.success('提交成功')
                    this.$refs.pager.loadData()
                })
        },
        currentDataModify(){
            this.showViewDetail = !this.showViewDetail
        },
        checkRate(){
            this.showRateViewDetail = !this.showRateViewDetail
        },
        handlerSearch: function() {
            let filter = {};
            filter.status = [this.status]
            if (this.searchData.supply_chain_id) {
                filter.supply_chain_id = [parseInt(this.searchData.supply_chain_id)]
            }
            if(this.searchData.unbind === 1) {
                filter.unbind = true
            } else if (this.searchData.unbind === 2) {
                filter.unbind = false
            }
            if(this.searchData.type) {
                filter.type = [this.searchData.type]
            }
            this.filter = filter
            this.loadData(this.currentRange)
        },
        handlerSort(column) {
            this.sort = [
                {
                    field: column.prop,
                    reverse: column.order === 'descending'
                }
            ]
        },
        getProductType(type){
            for (const opt of this.productTypeList) {
                if(type === opt.value) {
                    return opt.desc
                }
            }
        },
        getProductStatus(status){
            for (const opt of this.tabs) {
                if(status === opt.value) {
                    return opt.desc
                }
            }
        },
        getSupplyChain(id) {
            for (const opt of this.supplyChainList) {
                if(id === opt.id){
                    return opt.name
                }
            }
        },
        handleClose(){
            this.dialogVisible = !this.dialogVisible
        }
    }
}
</script>
<style scoped>
.pager{
    margin: 50px auto 0 auto !important;
}
.detail-image{
    max-width: 500px;
}
</style>
